/**
 * 用户信息相关通用方法
 * 可以通过 @common/userInfo 引用
 */
import * as apiConst from '@/service/api/api-const'

/**
 * 生成「获取用户信息」的完整 URL
 * @param {Object} params - 参数对象（如 { id, token, store_id }）
 * @returns {string} 完整的请求 URL
 */
export function getUserInfoUrl(params = {}) {
  const base = apiConst.getUserInfoUrl || ''

  const keys = Object.keys(params).filter(k => {
    const v = params[k]
    return v !== undefined && v !== null && v !== ''
  })

  if (!keys.length) {
    return base
  }

  const hasQuery = base.indexOf('?') !== -1
  const sep = hasQuery ? '&' : '?'
  const query = keys
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')

  return `${base}${sep}${query}`
}

export default {
  getUserInfoUrl
}




// WEBPACK FOOTER //
// ./src/store/common/userInfo.js